'use client';

import { httpMethods } from '@/constants/http-methods';
import { WatchListContent } from '@/types/watch-list-movie';
import { commonFetch, CommonFetchResponse } from '@/utils/common-fetch';
import { PagedListOfWatchListItem } from '@cinemark/profile-api-client';

class WatchListApiService {
  private readonly watchListUrl = '/papi/profiles/me/watch-list';
  private readonly watchListSimpleUrl = '/papi/profiles/me/watch-list-simple';

  async getWatchList(): Promise<CommonFetchResponse<WatchListContent>> {
    const response = await commonFetch<WatchListContent>(this.watchListUrl);
    return response;
  }

  async getWatchListSimple(): Promise<CommonFetchResponse<PagedListOfWatchListItem>> {
    const response = await commonFetch<PagedListOfWatchListItem>(this.watchListSimpleUrl);
    return response;
  }

  async addWatchListMovie(movieId: number): Promise<void> {
    await commonFetch(this.watchListUrl, {
      body: JSON.stringify({ movieId }),
      method: httpMethods.post,
    });
  }

  async removeWatchListMovie(movieId: number): Promise<void> {
    await commonFetch(`${this.watchListUrl}/${movieId}`, {
      method: httpMethods.delete,
    });
  }
}

export const watchListApiService = new WatchListApiService();
